/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GCPBucketLocationType } from './gCPBucketLocationType';


export interface GcpBucketsResponse { 
    /**
     * Timestamp when the bucket was created
     */
    create_time: Date;
    /**
     * The bucket id
     */
    id: string;
    /**
     * Geographic location where the bucket resides
     */
    location: string;
    location_type: GCPBucketLocationType;
    /**
     * Name of the bucket
     */
    name: string;
    /**
     * Timestamp when the bucket was last updated
     */
    update_time: Date;
}
export namespace GcpBucketsResponse {
}


